"use strict";
const _ = require('lodash');
function wineAndCiderTax(volume, alcoholPercentage) {
    let SEK_PER_LITER = 0;
    if (alcoholPercentage <= 2.25) {
        SEK_PER_LITER = 0;
    }
    else if (alcoholPercentage <= 4.5) {
        SEK_PER_LITER = 10.38;
    }
    else if (alcoholPercentage <= 7) {
        SEK_PER_LITER = 15.34;
    }
    else if (alcoholPercentage <= 8.5) {
        SEK_PER_LITER = 21.12;
    }
    else if (alcoholPercentage <= 15) {
        SEK_PER_LITER = 29.58;
    }
    else if (alcoholPercentage <= 18) {
        SEK_PER_LITER = 61.9;
    }
    else {
        throw new Error(`alcohol tax can not be calculated for wine with volume: ${volume}, and alcoholpercentage: ${alcoholPercentage}`);
    }
    return _.round(SEK_PER_LITER * volume, 3);
}
const alcoholTaxCalcFunctions = {
    Alcoholfree: () => 0,
    Cider: wineAndCiderTax,
    Wine: wineAndCiderTax,
    Beer: (volume, alcoholPercentage) => {
        if (alcoholPercentage <= 2.8) {
            return 0;
        }
        const SEK_PER_LITER_AND_PERCENT = 2.28;
        return _.round(SEK_PER_LITER_AND_PERCENT * volume * alcoholPercentage, 3);
    },
    MidRange: (volume, alcoholPercentage) => {
        let SEK_PER_LITER = 0;
        if (alcoholPercentage <= 1.25) {
            SEK_PER_LITER = 0;
        }
        else if (alcoholPercentage <= 15) {
            SEK_PER_LITER = 37.34;
        }
        else if (alcoholPercentage <= 22) {
            SEK_PER_LITER = 61.9;
        }
        else {
            throw new Error(`alcohol tax can not be calculated for midrange product with volume: ${volume}, and alcoholpercentage: ${alcoholPercentage}`);
        }
        return _.round(SEK_PER_LITER * volume, 3);
    },
    Spirits: (volume, alcoholPercentage) => {
        if (alcoholPercentage <= 1.2) {
            return 0;
        }
        const SEK_PER_LITER_PURE_ALCOHOL = 526.97;
        return _.round((SEK_PER_LITER_PURE_ALCOHOL * volume * alcoholPercentage) / 100, 3);
    },
};
module.exports = {
    alcoholTaxCalculator: article => {
        if (!article)
            return 0;
        const { alcoholPercentage, alcoholTaxClass, volume } = article;
        if (!alcoholTaxClass ||
            alcoholTaxClass === 'Alcoholfree' ||
            !volume ||
            !alcoholPercentage)
            return 0;
        return alcoholTaxCalcFunctions[alcoholTaxClass](volume, alcoholPercentage);
    },
};
